var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
import { textStyle as textStyleFn, system } from 'styled-system';
import { get } from '../tools/utils';
export var BaseSharedStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  font-family: ", ";\n  margin: 0;\n  &:focus {\n    outline: ", ";\n  }\n\n  ", ";\n"], ["\n  ", "\n\n  font-family: ", ";\n  margin: 0;\n  &:focus {\n    outline: ", ";\n  }\n\n  ", ";\n"])), function (_a) {
    var fontWeight = _a.fontWeight, fontStyle = _a.fontStyle, colors = _a.theme.colors;
    return "\n    font-weight: ".concat(fontWeight, ";\n    font-style: ").concat(fontStyle, ";\n    color: ").concat(colors['gray-900'], ";\n  ");
}, get.fonts('regular'), function (_a) {
    var outlineOnFocus = _a.outlineOnFocus;
    return outlineOnFocus ? 'inherit' : 'none';
}, system({
    overflowWrap: true,
}));
export var textBaseStyles = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  ", "\n"], ["\n  ", ";\n  ", ";\n\n  ", "\n"])), BaseSharedStyles, textStyleFn, function (_a) {
    var theme = _a.theme, size = _a.size;
    return "\n    line-height: ".concat(theme.font.body[size].lineHeight, ";\n    font-size: ").concat(theme.font.body[size].size, ";\n  ");
});
export var headerBaseStyles = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n\n  ", "\n"], ["\n  ", ";\n\n  ", "\n"])), BaseSharedStyles, function (_a) {
    var theme = _a.theme, size = _a.size;
    return "\n    line-height: ".concat(theme.font.heading[size].lineHeight, ";\n    font-size: ").concat(theme.font.heading[size].size, ";\n  ");
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map